import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FormattedDate, FormattedMessage, useIntl, IntlProvider } from 'react-intl';
/**
 * Use this instead of the default function from `react-intl`.
 * Keep props identical to the original `FormattedMessage`.
 *
 * Don't add complicated `values` in this hook as they're changing too much with the new theme.
 * Just add it in your specific use case.
 */
export const useFormatMessage = () => {
    const { formatMessage: formatMessageBase } = useIntl();
    const formatMessage = useCallback((descriptor, values) => {
        return formatMessageBase({ ...descriptor }, {
            b: (chunks) => _jsx("b", { children: chunks }),
            br: _jsx("br", {}),
            li: (chunks) => _jsx("li", { children: chunks }),
            p: (chunks) => _jsx("p", { children: chunks }),
            span: (chunks) => _jsx("span", { children: chunks }),
            ...values,
        });
    }, [formatMessageBase]);
    return { formatMessage };
};
export { FormattedDate, FormattedMessage, IntlProvider, useIntl };
